export const colors = {
  primary: "#36383C",
  secondary: "#EAEAEA",
};

export const theme = {
    color: "#878789"
}